{
    "raporrandevu": {
        "Baslik": "Afsprakenrapport",
        "Tarih": "Datum",
        "Kullanici": "Gebruiker",
        "Musteri": "Klant",
        "Sonuc": "Resultaat",
        "Gorusme": "Gesprek",
        "Aciklama": "Beschrijving",
        "Saat": "Uur",
        "Arama": "Zoeken",
        "Ara": "Zoek",
        "Kapat": "Sluiten",
        "Temizle": "Wissen",
        "BaslangicTarihi": "Startdatum",
        "BitisTarihi": "Einddatum",
        "BasSaat": "Starttijd",
        "BitSaat": "Eindtijd",
        "TGorusme": "T. Gesprek",
        "Ulasim": "Vervoer",
        "Not": "Notitie",
        "Gorusme1": "Eerste Gesprek",
        "Gorusme2": "2e Gesprek",
        "Arac": "Voertuig",
        "Diger": "Ander",
        "OjtVar": "OJT Aanwezig",
        "OjtYok": "Geen OJT",
        "Harita": "Kaart",
        "Duzenle": "Bewerken",
        "Sil": "Verwijderen",
        "EminMisiniz": "Weet u het zeker?",
        "GeriAlamazsiniz": "U kunt dit niet ongedaan maken!",
        "EvetSil": "Ja, verwijder het!",
        "Iptal": "Annuleren",
        "OjtBaslik": "On The Jobtraining",
        "OjtDegerlendirme": "Evaluatie",
        "OjtOlustur": "Ja, maak aan!",
        "Sayfa": "Pagina",
        "RandevuDetayi": "Afspraak Details",
        "Katilanlar": "Deelnemers",
        "GecmisRandevular": "Eerdere Afspraken",
        "Konum": "Locatie",
        "Vazgec": "Annuleren",
        "Bilgisi": "Informatie",
        "EskiRandevular": "Eerdere Afspr.",
        "BaslamaSaat": "Starttijd",
        "BitisSaat": "Eindtijd",
        "GorusmeSonucu": "Resultaat Gesprek",
        "SonIslemYapan": "Laatst Bewerkt Door",
        "SonGuncelleme": "Laatste Update",
        "Guncelle": "Bijwerken",
        "SaatKontrol": "Tijdscontrole",
        "Katilan": "Deelnemer",
        "Durum": "Status",
        "Onay": "Goedkeuring",
        "Onayladi": "Goedgekeurd",
        "Onaylamadi": "Niet Goedgekeurd",
        "Kapsam": "Bereik",
        "Kendi": "Eigen",
        "Takim": "Team",
        "Sube": "Filiaal",
        "Tam": "Volledig",
        "HedeflenenRandevular": "Gerichte Afspraken",
        "Islemler": "Acties",
        "OjtOlusurmaTooltip": "Maak On The Jobtraining",
        "HaritaTooltip": "Kaart",
        "GoruntuleTooltip": "Bekijken",
        "SilTooltip": "Verwijderen",
        "SilmeOnayMetni": "Deze actie kan niet ongedaan worden gemaakt. Weet u zeker dat u de record permanent wilt verwijderen?",
        "Excel": "Excel",
        "Ojt": "OJT"
    }
}
